import Car from '../../Assets/Images/car.png'
import Bike from '../../Assets/Images/Bike.png'
import Health from '../../Assets/Images/Personal.png'
import Life from '../../Assets/Images/Life.png'
import Truck from '../../Assets/Images/Commercial.png'
import HealthHover from '../../Assets/Images/HandHover.png';
import CarHover from '../../Assets/Images/CarHover.png';
import BikeHover from '../../Assets/Images/bikeHover.png';
import TruckHover from '../../Assets/Images/TempoHover.png';
import LifeHover from '../../Assets/Images/LifeHover.png';
const TabsProduct = {
    Motor: [
        {
            id: 1,
            product_name: "Car",
            image: Car,
            imageHover :  CarHover,
        },
        {
            id: 2,
            product_name: "Bike",
            image: Bike,
            imageHover: BikeHover,
            link: `${process.env.PUBLIC_URL}/motor-insurance`
        },
        {
            id: 5,
            product_name: "Truck",
            image: Truck,
            imageHover :  TruckHover,
        }
    ],
    Health: [
        {
            id: 3,
            product_name: "Health",
            image: Health,
            imageHover: HealthHover,
            link: `${process.env.PUBLIC_URL}/health-insurance`
        },
        {
            id: 6,
            product_name: "Personal Life",
            image: Health,
            imageHover: HealthHover,
            link: `${process.env.PUBLIC_URL}/health-insurance`
        }
    ],
    Life: [
        {
            id: 4,
            product_name: "Term Life",
            image: Life,
            imageHover :  LifeHover,
            link: `${process.env.PUBLIC_URL}/life-insurance`
        }
    ]
};


export default TabsProduct;
